import styled from 'styled-components';

const Subheading = styled.h2`
  font-size: 32px;
  font-weight: 400;
`;

export default Subheading;
